const locale = require('./reviewChanges.i18n.json');

/*@ngInject*/
const ReviewChangesModalController = function ($rootScope, $scope, options, submissionConstant, submissionMediator, formViewerConstant, coreMediator, coreConstant, loadingBarHandler) {

    $scope.i18n = locale;

    $scope.viewModel = {
        isLoading: true,
        isReadOnly: options.isReadOnly === true,
        title: options.title,
        continueButtonLabel: options.continueButtonLabel,
        continueButtonAction: options.continueButtonAction,
        navigateToOverviewBeforeContinue: options.navigateToOverviewBeforeContinue,
        showCancel: options.showCancel !== false,
        showMessage: options.showMessage,
        recentChangeList: [],
        loadingBarMessage : options.loadingBarMessage,
        shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat')
    };

    function loadRecentChanges() {

        function handleSuccess(result) {
            $scope.viewModel.recentChangeList = result.changeList;
            $scope.viewModel.isLoading = false;
        }

        $scope.viewModel.isLoading = true;
        submissionMediator.loadChangeSet(options.changeSetId).then(handleSuccess);
    }

    $scope.onSubmitChanges = function () {
        function onSuccess() {
            $scope.viewModel.isLoading = false;
            loadingBarHandler.hideLoadingBar();
            $scope.$close();
        }

        function onError(error) {
            $scope.viewModel.isLoading = false;
        }

        $scope.viewModel.isLoading = true;

        if ($scope.viewModel.navigateToOverviewBeforeContinue) {
            // we send them to the overview screen before we submit the modifications because
            // the forms are going to be different and will result in errors if we try to load them in
            // their current state, making sure to refresh the form id, since the
            // Submission form on the overview is now deleted and recreated as well.
            $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW, true /*refreshFormId*/);
        }

        if(_.isNil($scope.viewModel.continueButtonAction)){
            $scope.viewModel.isLoading = false;
            $scope.$close();
        }else{
            loadingBarHandler.showLoadingBar($scope.viewModel.loadingBarMessage);
            $scope.viewModel.continueButtonAction(options.entityId).then(onSuccess, onError);
        }

    };

    $scope.isButtonDisabled = function(){
        return $scope.viewModel.isLoading || (!$scope.viewModel.recentChangeList.length && !_.isNil($scope.viewModel.continueButtonAction));
    }

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    loadRecentChanges();
};

angular.module('gw-um-submission')
    .controller('reviewChangesModalController', ReviewChangesModalController);
